<template>
  <v-container class="mb-0 px-2">
    <v-data-table
      dense
      disable-sort
      hide-default-footer
      :headers="headers"
      :items="[...valores]"
      class="lotesListTable"
    >
      <template v-slot:item.numeroLote="{ item }">
        <b>{{ item.numeroLote }}</b>
      </template>
      <template v-slot:item.prestadorId="{ item }">
        <b>{{ item.prestadorId }}</b>
      </template>
      <template v-slot:item.numeroProtocolo="{ item }">
        <b>{{ item.numeroProtocolo }}</b>
      </template>
      <template v-slot:item.numeroNotaFiscal="{ item }">
        <b>{{ item.numeroNotaFiscal }}</b>
      </template>
      <template v-slot:item.valorInformado="{ item }">
        <b style="color:#32B88B">{{ item.valorInformado | formatPrice }}</b>
      </template>
      <template v-slot:item.valorConciliado="{ item }">
        <span style="color:#D0021B">{{ item.valorConciliado = Number(item.valorItensConciliacaoManual + item.valorItensConciliacaoAutomatica)| formatPrice }} </span>
        ({{ calcPercentConciliado(item) | formatPercent }})
      </template>
      <template v-slot:item.valorPago="{ item }">
        <span style="color:#32B88B">{{ item.valorPago | formatPrice }} </span>
        ({{ calcPercentLiberado(item) | formatPercent }})
      </template>
      <template v-slot:item.valorGlosado="{ item }">
        <span style="color:red">{{ item.valorGlosado | formatPrice }} </span>
        ({{ calcPercentGlosado(item) | formatPercent }})
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import moment from 'moment'
  export default {
    data() {
      return {
        showTable: true,
        headers: [
          {text: "Nome Arquivo", value: "nomeArquivo", align: "right", sortable: false },
          { text: "N lote", value: "numeroLote", align: "right", sortable: false },
          { text: "Id prestador", value: "prestadorId", align: "right", sortable: false },
          { text: "Protocolo", value: "numeroProtocolo", align: "right", sortable: false },
          { text: "N nota fiscal", value: "numeroNotaFiscal", align: "right", sortable: false },
          { text: "Vl.apresentado", value: "valorInformado", align: "right", sortable: false },
          { text: "Vl.conciliado", value: "valorConciliado", align: "right", sortable: false },
          { text: "Vl.liberado", value: "valorPago", align: "right", sortable: false },
          { text: "Vl.glosado", value: "valorGlosado", align: "right", sortable: false },
        ]
      }
    },
    props: {
      valores: Array,
    },
    filters: {
      formatData(val) {
        return  moment(val).format('DD/MM/YYYY')
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      formatPercent(value) {
        const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })
        return formatter.format(value)
      }
    },
    methods: {
      calcPercentConciliado (lote) {
        if (!lote.valorInformado || !lote.valorConciliado) return 0
        else return lote.valorConciliado/lote.valorInformado
      },
      calcPercentLiberado (lote) {
        if (!lote.valorInformado || !lote.valorPago) return 0
        else return lote.valorPago/lote.valorInformado
      },
      calcPercentGlosado (lote) {
        if (!lote.valorInformado || !lote.valorGlosado) return 0
        else return lote.valorGlosado/lote.valorInformado
      }
    }
  }
</script>

<style>
  tr:first-child.destaque {
    border-bottom: solid 2px #d1dcea;
    background-color: #d1dcea;
  }
</style>
